import { useEffect } from 'react';

export const useSaveQuery = (
  debouncedSearchQuery,
  setSuggestions,
  addSearchQuery,
) => {
  useEffect(() => {
    //load suggestions from cache
    const parsedQueries = JSON.parse(
      localStorage.getItem('cachedQueries') as string,
    );
    setSuggestions(Array.from(new Set(parsedQueries)));
    if (!debouncedSearchQuery) return;
    //send query to global search query table
    addSearchQuery({ query: debouncedSearchQuery });
    //cache queries for local autocomplete
    const cachedQueries = localStorage.getItem('cachedQueries');
    if (cachedQueries) {
      localStorage.setItem(
        'cachedQueries',
        JSON.stringify([debouncedSearchQuery, ...JSON.parse(cachedQueries)]),
      );
    } else {
      localStorage.setItem(
        'cachedQueries',
        JSON.stringify([debouncedSearchQuery]),
      );
    }
  }, [debouncedSearchQuery]);
};

export const useLoadQuery = (setCachedResults, debouncedSearchQuery) => {
  useEffect(() => {
    const cached = JSON.parse(localStorage.getItem('cachedResults') as string);
    if (cached) {
      setCachedResults(cached);
    }
  }, [debouncedSearchQuery]);
};

export const useQueryCache = (
  addSearchQuery,
  setCachedResults,
  setSuggestions,
  debouncedSearchQuery,
) => {
  useSaveQuery(debouncedSearchQuery, setSuggestions, addSearchQuery);
  useLoadQuery(setCachedResults, debouncedSearchQuery);
};
